import React from 'react';
import logo from '../../images/banner/funny404error-page.png';
const NotFound = () => {
    return (
        <div>
            <img className='w-100' src={logo} alt="" />
        </div>
    );
};

export default NotFound;